function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useCallback } from 'react';
import { useBiContextGetter } from "./BiContext";
export function useBiClick() {
  const getBiContext = useBiContextGetter();
  return useCallback(biEvent => {
    var _getBiContext;
    (_getBiContext = getBiContext()) === null || _getBiContext === void 0 || _getBiContext.logBiClick(biEvent);
  }, [getBiContext]);
}
export function useBiPageView() {
  const getBiContext = useBiContextGetter();
  return useCallback(biEvent => {
    var _getBiContext2;
    (_getBiContext2 = getBiContext()) === null || _getBiContext2 === void 0 || _getBiContext2.logBiPageView(biEvent);
  }, [getBiContext]);
}
export function useTransaction() {
  const getBiContext = useBiContextGetter();
  return useCallback(input => {
    const transactionName = typeof input === 'string' ? input : input.transactionName;
    const context = getBiContext();
    if (context) {
      return context.startTransaction(_objectSpread({
        transactionName
      }, typeof input === 'object' ? input : {}));
    }
    // Return no-op if no context
    return () => {};
  }, [getBiContext]);
}
export function useBiProvider() {
  var _getBiContext3;
  const getBiContext = useBiContextGetter();
  return (_getBiContext3 = getBiContext()) !== null && _getBiContext3 !== void 0 ? _getBiContext3 : {
    logBiClick: () => {},
    logBiPageView: () => {},
    logBiModalView: () => {},
    startTransaction: () => () => {}
  };
}